import { atom } from '@exodus/headless-ui';
import fromAssetAtom from './from-asset.js';
import fromWalletAccountAtom from './from-wallet-account.js';
const feeSpendableBalanceAtom = atom((get, { selectors }) => {
    const asset = get(fromAssetAtom).feeAsset;
    const walletAccount = get(fromWalletAccountAtom).toString();
    const getSpendableBalance = get(selectors.balances.getSpendable);
    const spendableBalance = getSpendableBalance({ assetName: asset.name, walletAccount });
    return spendableBalance || asset.currency.ZERO;
});
export default feeSpendableBalanceAtom;
